import api from "./client"
import type { Payment } from "../types"

export async function getPayments(): Promise<Payment[]> {
  const { data } = await api.get<Payment[]>("/payments")
  return data
}

export async function createPayment(params: Record<string, unknown>): Promise<Payment> {
  const { data } = await api.post<Payment>("/payments", { payment: params })
  return data
}

export async function updatePayment(id: number, params: Record<string, unknown>): Promise<Payment> {
  const { data } = await api.patch<Payment>(`/payments/${id}`, { payment: params })
  return data
}

export async function deletePayment(id: number): Promise<void> {
  await api.delete(`/payments/${id}`)
}
